export const teamRouting = [
  {
    path: "/labor/team/list",
    name: "labor-team-list",
    meta: { title: "劳务班组" },
    component: () =>
      import(
        /* webpackChunkName: "labor-team-list" */ "@/views/labor/labor-team/list/index.vue"
      ),
  },
];
